import { render, staticRenderFns } from "./MultiAutoTest.vue?vue&type=template&id=11aa79a1&scoped=true"
import script from "./MultiAutoTest.vue?vue&type=script&lang=js"
export * from "./MultiAutoTest.vue?vue&type=script&lang=js"
import style0 from "./MultiAutoTest.vue?vue&type=style&index=0&id=11aa79a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11aa79a1",
  null
  
)

export default component.exports